import { Col, Flex, Form, Input, Radio, Row } from "antd";
import styles from "./index.module.less";
import CitySelector from "./components/CitySelector";
import InputBox from "./components/InputBox";
import { useEffect, useState } from "react";
import ModalCloseIcon from "@/assets/imgs/modal_close.svg?react";
import classNames from "classnames";
import message from "@/plugins/message";
import SMSCodeBtn from "./components/SMSCodeBtn";
import { useWatch } from "antd/es/form/Form";
import { uuid4V1 } from "@/utils";
import SVGIcon from "@/components/SVGIcon";
import ContactMain from "./components/Main";

const MobileContactModal = ({
  visible,
  title,
  onClose,
}: {
  visible: boolean;
  title?: string;
  onClose?: () => void;
}) => {
  if (!visible) {
    return null;
  }
  const handleClose = () => {
    setClosing(true);
    setTimeout(() => {
      onClose?.();
    }, 300);
  };
  const [closing, setClosing] = useState(false);
  return (
    <div className={styles.contactModal}>
      <div
        className={classNames(styles.mask, {
          [styles.fadeOut]: closing,
          [styles.fadeIn]: !closing,
        })}
      ></div>
      <ContactMain onClose={handleClose} />
    </div>
  );
};

export default MobileContactModal;
